import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { PuntoList } from "./list";
import { map, unmap, PuntosRuta } from "./logic";

type Entity = models.RutaSucursalDTO;
export interface Props {
    value: Entity[] | undefined;
    onChange: (x: Entity[]) => void;
    readonly?: boolean;
    error?: kea.FieldError;
}


export class SegmentosList extends React.PureComponent<Props> {
    handleOnChange = async (next: PuntosRuta) => {
        await this.props.onChange(unmap(next));
    };

    render() {
        return (
            <PuntoList value={map(this.props.value || [])} onChange={this.handleOnChange} error={this.props.error} />
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/rutas/edit/puntos/listSegmentos.tsx